"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsedDropdownMenuItem = void 0;
const classnames_1 = __importDefault(require("classnames"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const utils_1 = require("../../utils");
const atoms_1 = require("../atoms");
const enhanced_1 = require("../enhanced");
const tray_1 = require("../tray");
const SimpleDesktopDropdownMenu_1 = require("./SimpleDesktopDropdownMenu");
const minWidth = 399;
const InnerMenu = styled_components_1.default.div `
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	&:hover {
		visibility: visible;
		section {
			opacity: 1;
		}
	}
	position: absolute;
	right: 0px;
	top: 0;
	section {
		opacity: ${(p) => (p.menuOpen ? 1 : 0)};
		transition: opacity 0.5s ${(p) => p.theme.easing};
	}

	ul li a.simple-menu-link {
		padding: 16px;
	}
`;
const InnerEnhanced = styled_components_1.default.div `
	background: ${(p) => p.theme.palette.background.paper};
	margin: 0;
	position: absolute;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
	padding: 0;
	width: ${(p) => p.width}px;
	max-width: ${(p) => p.width}px;
	overflow: hidden;
	top: -${(p) => Math.max(0, Math.floor(p.top - p.theme.navHeight - p.topOffset))}px;

	> section,
	> div {
		padding-left: 40px;
		padding-right: 16px;
	}

	.h2 {
		margin-bottom: 8px;
	}

	p {
		line-height: 24px;
	}

	.describe,
	.external {
		max-width: 100%;
		white-space: initial;
		text-transform: initial;
	}

	.main-links,
	.external {
		position: relative;
		a:first-child .h3 {
			margin-top: 0;
		}
	}

	.describe {
		padding-top: 40px;
		padding-bottom: 32px;
	}

	.main-links {
		border-right: initial;
		padding-bottom: 40px;
	}

	.external {
		padding-top: 40px;
		padding-bottom: 40px;
		.h4 {
			margin-top: 0;
		}
	}

	&& {
		a:hover {
			color: ${(p) => p.theme.palette.accent.text};
			text-decoration: none;
		}
	}
`;
const CollapsedDropdownMenuItem = ({ link, linkKey, isEnhancedDropdown, menuId, locale, topOffset, }) => {
    var _a;
    const [innerMenuOpen, setInnerMenuOpen] = (0, react_1.useState)(false);
    const [right, setRight] = (0, react_1.useState)(0);
    const [top, setTop] = (0, react_1.useState)(0);
    const openInnerMenu = (0, react_1.useCallback)(() => {
        setInnerMenuOpen(true);
    }, [setInnerMenuOpen]);
    const closeInnerMenu = (0, react_1.useCallback)(() => {
        setInnerMenuOpen(false);
    }, [setInnerMenuOpen]);
    const toggleInnerMenu = (0, react_1.useCallback)(() => {
        setInnerMenuOpen(!innerMenuOpen);
    }, [innerMenuOpen, setInnerMenuOpen]);
    const outerMenuClasses = (0, classnames_1.default)("outer-menu", { dropdown: isEnhancedDropdown });
    const enhanced = link.enhancedDropdown || {};
    const { describeColumn = {}, externalColumn = {} } = enhanced;
    const kids = link.kids || [];
    let customMainLinks;
    if (enhanced && enhanced.mainLinksNode) {
        customMainLinks = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, enhanced.mainLinksNode), { links: kids, locale });
    }
    let customExternalColumn;
    if (externalColumn && externalColumn.externalColumnNode) {
        customExternalColumn = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, externalColumn.externalColumnNode), Object.assign(Object.assign({}, externalColumn), { locale }));
    }
    const menuItemRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        function setSize() {
            if (menuItemRef && menuItemRef.current !== null) {
                const { right, top } = menuItemRef.current.getBoundingClientRect();
                if (right && top) {
                    setRight(right);
                    setTop(top);
                }
            }
        }
        setSize();
    }, [menuItemRef, setTop, setRight, innerMenuOpen]);
    const clientWidth = (0, epic_games_nav_shared_1.getClientWidth)();
    const innerMenuWidth = right === 0 ? minWidth : Math.floor(clientWidth - right);
    const mainLinkBorderBottom = (0, utils_1.isValidExternalColumn)((_a = link === null || link === void 0 ? void 0 : link.enhancedDropdown) === null || _a === void 0 ? void 0 : _a.externalColumn);
    return (react_1.default.createElement(tray_1.TrayItem, { ref: menuItemRef, role: "menuitem", tabIndex: 0, key: `outer-menu-${linkKey}`, className: outerMenuClasses, onMouseEnter: openInnerMenu, onMouseLeave: closeInnerMenu, isMenuToggle: true, toggleMenu: toggleInnerMenu, onKeyUp: (0, shared_1.useHandleKeyUp)(toggleInnerMenu, toggleInnerMenu), onMouseDown: epic_games_nav_shared_1.stopFocusOnClick },
        react_1.default.createElement("div", { className: "tray-item-inner" },
            react_1.default.createElement("span", { className: "outer-menu-title" }, link.title),
            react_1.default.createElement(atoms_1.ArrowIcon, null)),
        react_1.default.createElement(InnerMenu, { menuOpen: innerMenuOpen }, isEnhancedDropdown ? (react_1.default.createElement(InnerEnhanced, { key: `inner-menu-${linkKey}`, width: innerMenuWidth || minWidth, top: top, topOffset: topOffset },
            react_1.default.createElement(enhanced_1.DescribeColumn, Object.assign({}, describeColumn, { locale: locale })),
            customMainLinks || react_1.default.createElement(enhanced_1.MainLinks, { links: link.kids, borderBottom: mainLinkBorderBottom, locale: locale }),
            customExternalColumn || react_1.default.createElement(enhanced_1.ExternalColumn, Object.assign({}, externalColumn, { locale: locale })))) : (react_1.default.createElement(SimpleDesktopDropdownMenu_1.SimpleDesktopDropdownMenu, { links: kids, controlMenuOpen: true, controlMenuOpenValue: innerMenuOpen, menuId: menuId, disableMouseLeave: true })))));
};
exports.CollapsedDropdownMenuItem = CollapsedDropdownMenuItem;
//# sourceMappingURL=CollapsedDropdownMenuItem.js.map